import {SET_OWNER_SETTING, SET_SETTING, RESET_SETTINGS} from "@/store/mutation-types"

export default {
	methods: {
		saveActiveTab(tabName) {
			this.setUserSetting('active-tab', tabName)
		},
		getActiveTab() {
			return this.getSettingByKey('active-tab')
		},
		saveLastVisited(itemId) {
			this.setUserSetting('last-visited', itemId)
		},
		setUserSetting(settingKey, settingValue) {
			if (this.moduleName !== '' && this.moduleName !== null && this.moduleName !== undefined) {
				this.$store.dispatch(SET_SETTING, {module: this.moduleName, settings: settingValue, key: settingKey})
			}
		},
		resetUserSettings(){
			this.$store.dispatch(RESET_SETTINGS, {})
		},
		isLastVisited(itemId) {
			itemId = String(itemId)
			let lastVisited = this.getSettingByKey('last-visited')
			if (this._.includes(lastVisited, ',')) {
				lastVisited = lastVisited.split(',')
				return this._.includes(lastVisited, itemId)
			}
			return Boolean(String(lastVisited) === itemId)
		},
		getSettingByKey(settingKey) {
			let data = {module: this.moduleName, key: settingKey}
			if (this.$store.getters.hasSetting(data)) {
				return this.$store.getters.getSetting(data)
			}
			return null
		},
		getOwnerSettingByKey(settingKey) {
			if (this.$store.getters.hasOwnerSetting(settingKey)) {
				return this.$store.getters.getOwnerSetting(settingKey)
			}
			return null
		},
		setOwnerSetting(settingKey, settingValue) {
			this.$store.dispatch(SET_OWNER_SETTING, {settings: settingValue, key: settingKey})
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/user-settings.js